// eslint-disable-next-line no-unused-vars
import { INNER_ROOT, USER_ROOT, transmission, WEB_METHODS } from '../../network/index'

const ROOT = '/order'

const state = {}

const mutations = {}

/**
 * Actions Naming Rule
 * 기본문법 : CamelCase
 * 작문 : { 메소드 }{ 명칭 }{ 결과타입 }
 *
 * 메소드 예 *
 *  get, post, put, delete 등
 * 명칭 예 *
 *  상담사 : counselor 등
 * 결과 타입 예 *
 *  목록 : List
 *  단건결과 : 없음 등
 */
const actions = {
  /**
   * 여행지도 > 주문상세 리스트 조회
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getTravelMapOrdDtlList ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/travel-map-ord-dtls`, payload)
  },
  /**
   * 이용중 주문 상세 조회
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getUseOrdDtlNoGuide ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/use-ord-dtl-no-guide`)
  },
  /**
   * 과거 진행한 주문 상세 조회 > (만족도조사)가이드평가 여부 확인용
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getOldOrdDtl ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/old-ord-dtl`)
  },
  /**
   * 만족도 조사 이용기간 및 제출 여부 조회
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getLastOrdDtl ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/last-ord-dtl`)
  }
}

export default { state, mutations, actions }
